import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { appConfig } from '~/app.config';
import { SportGroup } from '~/attendee/interfaces/sport-group.interface';
import { VtmnButtonVariantEnum } from '~/component/buttons/vtmn-button/enum/vtmn-button-variant.enum';
import { ChipsComponent } from '~/component/chips/chips.component';

@Component({
  selector: 'app-attendee-sport-filter',
  templateUrl: './sport-filter.component.html',
  styleUrls: ['./sport-filter.component.scss'],
})
export class AttendeeSportFilterComponent implements OnInit {
  @Input() public selectedSportGroupIdsFromUrl: number[];
  @Output() public selected = new EventEmitter<SportGroup>();

  @ViewChild(ChipsComponent) public chips: ChipsComponent;

  public readonly sportGroupCollection = Object.values(
    appConfig.filters.sportGroups
  );
  public readonly vtmnButtonVariantEnum = VtmnButtonVariantEnum;

  public defaultSelectedSportGroup: SportGroup;
  public selectedSportGroup: SportGroup = null;

  constructor(private readonly translateService: TranslateService) {}

  public ngOnInit(): void {
    if (this.selectedSportGroupIdsFromUrl) {
      this.defaultSelectedSportGroup = this.sportGroupCollection.find(
        (sportGroup) => {
          return (
            JSON.stringify(sportGroup.idCollection) ===
            JSON.stringify(this.selectedSportGroupIdsFromUrl)
          );
        }
      );
      if (this.defaultSelectedSportGroup) {
        this.selectedSportGroup = this.defaultSelectedSportGroup;
      }
    }

    this.selected.subscribe((value) => {
      this.selectedSportGroup = value;
    });
  }

  public get filterLabel(): string {
    return this.selectedSportGroup?.title
      ? this.translateService.instant(this.selectedSportGroup.title)
      : this.translateService.instant('attende.sport_filter.button.label');
  }

  public updateSelectedSportGroup(value: SportGroup): void {
    this.selected.emit(value);
    this.chips.toggleDialog();
  }
}
